/* SOLARA FAQ - Field Manual behaviour */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.faqInit === '1') return;
    root.dataset.faqInit = '1';

    var dataEl = root.querySelector('[data-faq-data]');
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch (err) { console.error('[solara-faq] config parse error', err); return; }

    var mains = Array.isArray(data.mains) ? data.mains : [];
    var tables = data.tables || {};
    if (!mains.length) return;

    var mainsEl = root.querySelector('[data-faq-mains]');
    var subsEl  = root.querySelector('[data-faq-subs]');
    var panelEl = root.querySelector('[data-faq-panel]');
    if (!mainsEl || !subsEl || !panelEl) return;

    var state = {
      mainId: mains[0].id,
      subId:  mains[0].subs && mains[0].subs[0] ? mains[0].subs[0].id : null,
      openQs: {}
    };

    /* ---- URL hash deep-link (#faq=main/sub) ---- */
    function readHash() {
      var m = (window.location.hash || '').match(/faq=([^/]+)(?:\/([^/]+))?/);
      if (!m) return;
      var main = mains.find(function (x) { return x.id === m[1]; });
      if (!main) return;
      state.mainId = main.id;
      if (m[2]) {
        var sub = (main.subs || []).find(function (x) { return x.id === m[2]; });
        if (sub) state.subId = sub.id;
        else state.subId = main.subs && main.subs[0] ? main.subs[0].id : null;
      } else {
        state.subId = main.subs && main.subs[0] ? main.subs[0].id : null;
      }
    }

    function writeHash() {
      if (!state.mainId) return;
      var h = 'faq=' + state.mainId + (state.subId ? '/' + state.subId : '');
      if ('#' + h !== window.location.hash) {
        history.replaceState(null, '', '#' + h);
      }
    }

    /* ---- helpers ---- */
    function el(tag, attrs, kids) {
      var n = document.createElement(tag);
      if (attrs) for (var k in attrs) {
        if (k === 'class') n.className = attrs[k];
        else if (k === 'text') n.textContent = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k.indexOf('data-') === 0 || k === 'role' || k === 'aria-label' || k.indexOf('aria-') === 0) n.setAttribute(k, attrs[k]);
        else n[k] = attrs[k];
      }
      if (kids) (Array.isArray(kids) ? kids : [kids]).forEach(function (c) {
        if (c == null) return;
        n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
      return n;
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function currentMain() { return mains.find(function (m) { return m.id === state.mainId; }) || mains[0]; }
    function currentSub() {
      var m = currentMain();
      if (!m || !m.subs) return null;
      return m.subs.find(function (s) { return s.id === state.subId; }) || m.subs[0];
    }

    /* ---- table rendering ---- */
    function renderTable(key) {
      var t = tables[key];
      if (!t || !Array.isArray(t.rows)) return '';
      var head = (t.head || []).map(function (h) { return '<th>' + escapeHtml(h) + '</th>'; }).join('');
      var rows = t.rows.map(function (r) {
        return '<tr>' + r.map(function (cell) { return '<td>' + escapeHtml(cell) + '</td>'; }).join('') + '</tr>';
      }).join('');
      return '<div class="faq-table-wrap"><table class="faq-table"><thead><tr>' + head + '</tr></thead><tbody>' + rows + '</tbody></table></div>';
    }

    function renderAnswer(a) {
      if (typeof a !== 'string') return '';
      var tableMatch = a.match(/^TABLE::(.+)$/);
      if (tableMatch) return renderTable(tableMatch[1].trim());
      // Paragraphs split by blank lines
      var paras = a.split(/\n\s*\n/);
      return paras.map(function (p) { return '<p>' + escapeHtml(p).replace(/\n/g, '<br>') + '</p>'; }).join('');
    }

    /* ---- renderers ---- */
    function renderMains() {
      mainsEl.innerHTML = '';
      mains.forEach(function (m) {
        var count = (m.subs || []).reduce(function (s, sub) { return s + (sub.faqs ? sub.faqs.length : 0); }, 0);
        var btn = el('button', {
          type: 'button',
          'class': 'faq-main-pill' + (m.id === state.mainId ? ' is-active' : ''),
          role: 'tab',
          'aria-selected': m.id === state.mainId ? 'true' : 'false',
          'data-main': m.id
        });
        btn.appendChild(document.createTextNode(m.label));
        btn.appendChild(el('span', { 'class': 'faq-count', text: '(' + count + ')' }));
        btn.addEventListener('click', function () {
          if (state.mainId === m.id) return;
          state.mainId = m.id;
          state.subId = m.subs && m.subs[0] ? m.subs[0].id : null;
          state.openQs = {};
          renderAll();
        });
        mainsEl.appendChild(btn);
      });
    }

    function renderSubs() {
      subsEl.innerHTML = '';
      var m = currentMain();
      if (!m || !m.subs) return;
      m.subs.forEach(function (s) {
        var btn = el('button', {
          type: 'button',
          'class': 'faq-sub-pill' + (s.id === state.subId ? ' is-active' : ''),
          role: 'tab',
          'aria-selected': s.id === state.subId ? 'true' : 'false',
          'data-sub': s.id,
          text: s.label
        });
        btn.addEventListener('click', function () {
          if (state.subId === s.id) return;
          state.subId = s.id;
          state.openQs = {};
          renderPanel();
          renderSubs();
          writeHash();
        });
        subsEl.appendChild(btn);
      });
    }

    function renderPanel() {
      var s = currentSub();
      panelEl.innerHTML = '';
      if (!s || !s.faqs || !s.faqs.length) {
        panelEl.appendChild(el('div', { 'class': 'faq-panel-empty', text: 'No questions in this section yet.' }));
        return;
      }
      var list = el('div', { 'class': 'faq-list', role: 'list' });
      s.faqs.forEach(function (f, idx) {
        var key = state.mainId + '/' + state.subId + '/' + idx;
        var isOpen = !!state.openQs[key];
        var item = el('div', {
          'class': 'faq-item' + (isOpen ? ' is-open' : ''),
          role: 'listitem'
        });
        var qId = 'faq-q-' + state.mainId + '-' + state.subId + '-' + idx;
        var aId = 'faq-a-' + state.mainId + '-' + state.subId + '-' + idx;

        var btn = el('button', {
          type: 'button',
          'class': 'faq-q',
          id: qId,
          'aria-expanded': isOpen ? 'true' : 'false',
          'aria-controls': aId
        });
        btn.appendChild(el('span', { text: f.q }));
        btn.appendChild(el('span', { 'class': 'faq-icn', 'aria-hidden': 'true' }));

        var aWrap = el('div', { 'class': 'faq-a-wrap', id: aId, role: 'region', 'aria-labelledby': qId });
        var a = el('div', { 'class': 'faq-a' });
        var aInner = el('div', { 'class': 'faq-a-inner', html: renderAnswer(f.a) });
        a.appendChild(aInner);
        aWrap.appendChild(a);

        btn.addEventListener('click', function () {
          state.openQs[key] = !state.openQs[key];
          item.classList.toggle('is-open', !!state.openQs[key]);
          btn.setAttribute('aria-expanded', state.openQs[key] ? 'true' : 'false');
        });

        item.appendChild(btn);
        item.appendChild(aWrap);
        list.appendChild(item);
      });
      panelEl.appendChild(list);
    }

    function renderAll() {
      renderMains();
      renderSubs();
      renderPanel();
      writeHash();
    }

    readHash();
    renderAll();

    window.addEventListener('hashchange', function () {
      readHash();
      renderAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.solara-faq').forEach(init);
    });
  } else {
    document.querySelectorAll('.solara-faq').forEach(init);
  }

  // Shopify section reload (theme editor)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target.querySelector('.solara-faq');
      if (sec) init(sec);
    });
  }
})();